import { AbstractTableToolsPanel } from "../AbstractTableToolsPanel";
import { Component } from "../../../..";
import { ComponentCreator, ComponentFactory } from "../../../../page/ComponentFactory";
import { PanelProps } from "../../../panel/PanelProps";
import { Table } from "../../../table/Table";

export abstract class AbstractCustomTableToolsPanel extends AbstractTableToolsPanel {
    constructor(table: Table, props?: Partial<PanelProps>) {
        super(table, props);
        this.allowDropInDesigner = true;
    }

    addTool(tool: ComponentCreator): Component {
        const finalizedTool = ComponentFactory.createCommon(tool);
        this.add(finalizedTool);
        finalizedTool._designer = this.table._designer;
        return finalizedTool;
    }
}
